"use client";

import { PhoneNumber } from "@/components/phoneNumber/phoneNumber.component";

import { isRichTextBrandColorToken } from "./richTextBrandColorTokens";

/**
 * Portable Text inline object that renders the campaign/settings phone number.
 * Desktop/mobile TFNs come from CampaignProvider + SettingsProvider.
 */
export function RichTextInlinePhoneNumber({
  value,
  className,
}: RichTextInlinePhoneNumberProps) {
  const token = value?.token;
  const colorStyle =
    typeof token === "string" && isRichTextBrandColorToken(token)
      ? { color: `var(--color-${token})` }
      : undefined;

  return (
    <PhoneNumber
      showNumber
      formatNumber
      className={className ?? "underline underline-offset-2"}
      desktopClassName="lg:inline"
      mobileClassName="inline"
      style={colorStyle}
    />
  );
}

type RichTextInlinePhoneNumberProps = {
  value?: {
    token?: string;
  };
  className?: string;
};
